<template>
  <article v-if="post" class="wagb-blog wagb-blog--post">
    <h1 class="wagb-blog__post-title">{{ post.listTitle }}</h1>

    <!-- 真实内容图（content/ 目录） -->
    <figure class="wagb-blog__figure wagb-blog__figure--photo">
      <img :src="post.image" :alt="post.imageAlt" width="960" height="540" loading="eager" />
    </figure>

    <section
      v-for="(section, idx) in post.sections"
      :key="idx"
      class="wagb-blog__section"
    >
      <h2 v-if="idx > 0">{{ section.title }}</h2>
      <p v-for="(para, pIdx) in section.paragraphs" :key="'p-' + pIdx">{{ para }}</p>
      <p v-if="section.conclusion" class="wagb-blog__conclusion">
        <strong>Kesimpulan:</strong> {{ section.conclusion }}
      </p>
      <p v-for="(para, pIdx) in section.paragraphsAfter" :key="'pa-' + pIdx">{{ para }}</p>
      <p v-if="section.listIntro">{{ section.listIntro }}</p>
      <ul v-if="section.list" class="wagb-blog__list">
        <li v-for="item in section.list" :key="item">{{ item }}</li>
      </ul>
      <table v-if="section.table" class="wagb-blog__table">
        <thead>
          <tr>
            <th v-for="head in section.table.headers" :key="head">{{ head }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(row, rIdx) in section.table.rows" :key="rIdx">
            <td v-for="(cell, cIdx) in row" :key="cIdx">{{ cell }}</td>
          </tr>
        </tbody>
      </table>
    </section>

    <section class="wagb-blog__section">
      <h2>FAQ</h2>
      <div class="wagb-blog__faq">
        <div v-for="item in post.faq" :key="item.q" class="wagb-blog__faq-item">
          <p class="wagb-blog__faq-q"><strong>{{ item.q }}</strong></p>
          <p class="wagb-blog__faq-a">{{ item.a }}</p>
        </div>
      </div>
    </section>

    <!-- UI 效果贴图：相关文章卡片 -->
    <section class="wagb-blog__section wagb-blog__latest">
      <h2>{{ latestArticles.title }}</h2>
      <p>{{ latestArticles.intro }}</p>
      <div class="wagb-blog__grid wagb-blog__grid--related">
        <article
          v-for="related in relatedPosts"
          :key="related.slug"
          class="wagb-blog__ui-card"
        >
          <h3 class="wagb-blog__card-title">
            <span class="wagb-blog__card-badge" aria-hidden="true">🟦</span>
            {{ related.cardTitle }}
          </h3>
          <p class="wagb-blog__card-desc">{{ related.description }}</p>
          <p class="wagb-blog__card-date">📅 {{ related.date }}</p>
          <router-link :to="related.path" class="wagb-blog__card-link">
            👉 Read More
          </router-link>
        </article>
      </div>
    </section>
  </article>
</template>

<script>
import '@/css/wagbappro-blog.scss';
import {
  getPostBySlug,
  getRelatedPosts,
  latestArticles as latestArticlesMeta,
} from '@/data/wagbappro/blog-id';

export default {
  name: 'BlogPostContent',
  props: {
    slug: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      latestArticles: latestArticlesMeta,
    };
  },
  computed: {
    post() {
      return getPostBySlug(this.slug);
    },
    relatedPosts() {
      return getRelatedPosts(this.slug);
    },
  },
};
</script>
